import React from "react";
import { T } from "services/lang/LanguageService";

import DashboardRoute from "components/fragments/dashboard/components/DashboardRoute";
import DashboardTab from "components/fragments/dashboard/components/tab/DashboardTab";
import { Button } from "primereact/button";
import { createHashRouter } from "react-router-dom";
import VikingMaltBestBatchCalculator from "../../company-specific/viking-malt/best-batch-calculator/VikingMaltBestBatchCalculator";
import DatasetWindow from "../../dashboard/dataset-window";
import DevSandbox from "../../dashboard/dev-sandbox/DevSandbox";
import Airflow from "../airflow/Airflow";
import AirflowTasks from "../airflow/AirflowTasks";
import AuthorizationManagementPage from "../authorization-management/AuthorizationManagementPage";
import CompanyFilesPage from "../company-files/CompanyFilesPage";
import NotFound from "../error/NotFound";
import Layout from "../measurement-devices/components/Layout";
import MaintenanceFormWrapper from "../measurement-devices/components/Maintenance/MaintenanceFormWrapper";
import ProjectDropDown from "../measurement-devices/components/ProjectDropDown";
import MeasurementDevicesRoot from "../measurement-devices/MeasurementDevicesRoot";
import Analytics from "../measurement-devices/routes/Analytics";
import Devices from "../measurement-devices/routes/Devices";
import EditDeviceForm from "../measurement-devices/routes/EditDeviceForm";
import EditObjectForm from "../measurement-devices/routes/EditObjectForm";
import ErrorPage from "../measurement-devices/routes/ErrorPage";
import Jobs from "../measurement-devices/routes/Jobs";
import Maintenance from "../measurement-devices/routes/Maintenance";
import NewDeviceForm from "../measurement-devices/routes/NewDeviceForm";
import NewObjectForm from "../measurement-devices/routes/NewObjectForm";
import Objects from "../measurement-devices/routes/Objects";
import Settings from "../measurement-devices/routes/Settings";
import SingleObjectMap from "../measurement-devices/routes/SingleObjectMap";
import AirflowTaskConfigurator from "../scheduled-task-airflow/AirflowTaskConfigurator";
import EasasMainLayout from "./EasasMainLayout";
import MaintenanceLayout from "../measurement-devices/components/Maintenance/MaintenanceLayout";
import MaintenanceSettings from "../measurement-devices/components/Maintenance/MaintenanceSettings";

const InvalidStatePage = () => {
  return <div className="flex justify-content-center">
    <div>
      <h2>{T("label.invalid-state-page.invalid-state")}</h2>
      <p>{T("label.invalid-state-page.this-should-not-be-displayed-please-report")}</p>
      <div className="justify-content-center">
        <Button label={T("action.go-back")} className="p-button-text w-full" onClick={() => window.history.back()} />
      </div>
    </div>
  </div>
}

const easasMainRouter = createHashRouter([
  {
    path: "/",
    element: <EasasMainLayout />,
    children: [
      { index: true, element: <InvalidStatePage /> },
      { path: "/sandbox", element: <DevSandbox /> },
      { path: "/files", element: <CompanyFilesPage /> },
      { path: "/airflow", element: <Airflow /> },
      { path: "/airflow/:dagId", element: <AirflowTasks /> },
      { path: "/airflow/:dagId/:taskId", element: <AirflowTaskConfigurator /> },
      { path: "/auth-management", element: <AuthorizationManagementPage /> },
      { path: "/datasets", element: <DatasetWindow /> },
      { path: "/instant-job-run", element: <VikingMaltBestBatchCalculator /> },
      {
        path: "/dashboard/:dashboardId",
        element: <DashboardRoute />,
        children: [{ path: "tab/:tabId", element: <DashboardTab /> }],
      },
      {
        path: "/mdm",
        element: <MeasurementDevicesRoot />,
        errorElement: <ErrorPage msg="" />,
        children: [
          { path: "", element: <ProjectDropDown /> },
          {
            path: "project/:projectId",
            element: <MaintenanceLayout />,
            children: [
              { path: "objects/:objectId", element: <EditObjectForm /> },
              { path: "devices/:deviceId", element: <EditDeviceForm /> },
              { path: "maintenance", element: <Maintenance /> },
              { path: "maintenance/:maintenanceId", element: <MaintenanceFormWrapper /> },
              { path: "map/:objectId", element: <SingleObjectMap /> },
              { path: "settings", element: <MaintenanceSettings /> },
            ],
          },
          {
            path: ":projectId",
            element: <Layout />,
            children: [
              { index: true, element: <Objects /> },
              { path: "objects/new", element: <NewObjectForm /> },
              { path: "objects/:objectId", element: <EditObjectForm /> },
              { path: "devices", element: <Devices /> },
              { path: "devices/:deviceId", element: <EditDeviceForm /> },
              { path: "devices/new", element: <NewDeviceForm /> },
              { path: "analytics", element: <Analytics /> },
              { path: "jobs", element: <Jobs /> },
              { path: "maintenance", element: <Maintenance /> },
              { path: "maintenance/:maintenanceId", element: <MaintenanceFormWrapper /> },
              { path: "map/:objectId", element: <SingleObjectMap /> },
              { path: "settings", element: <Settings /> },
            ],
          },
        ],
      },
      { path: "/*", element: <NotFound /> },
    ],
  },
]);

export default easasMainRouter;

